// CompoundFormDialog.jsx
// ... (CompoundFormDialog, ManagerSettingDialog, and CMTAssignDialog)

// TransferListComponent.jsx
import React from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Button,
  Paper,
  Typography,
} from "@mui/material";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

const TransferListComponent = ({ left, right, setLeft, setRight }) => {
  const [checked, setChecked] = React.useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const customList = (items) => (
    <Paper sx={{ width: 250, height: 300, overflow: "auto" }}>
      <List dense component="div" role="list">
        {Array.isArray(items) && items.length > 0 ? (
          items.map((value) => {
            const labelId = `transfer-list-item-${value.id}-label`;

            return (
              <ListItem
                key={value.id}
                role="listitem"
                button
                onClick={handleToggle(value)}
              >
                <ListItemIcon>
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>
                <ListItemText
                  id={labelId}
                  primary={`${value.username} (${value.email})`}
                />
              </ListItem>
            );
          })
        ) : (
          <ListItem>
            <ListItemText primary="No items available" />
          </ListItem>
        )}
      </List>
    </Paper>
  );

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item>
        <Typography variant="h6">Available CMTs</Typography>
        {customList(left)}
      </Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            onClick={handleAllRight}
            disabled={left.length === 0}
          >
            ≫
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
          >
            ›
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
          >
            ‹
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            onClick={handleAllLeft}
            disabled={right.length === 0}
          >
            ≪
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h6">Assigned CMTs</Typography>
        {customList(right)}
      </Grid>
    </Grid>
  );
};

export default TransferListComponent;
